/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Harden_Output6Inputs */

const en_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watched pipeline`)
};

const ar_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خط أنابيب مراقب`)
};

const bn_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নজরদারি করা পাইপলাইন`)
};

const de_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beobachtete Pipeline`)
};

const es_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tubería vigilada`)
};

const fr_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline surveillé`)
};

const pt_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline monitorado`)
};

const zh_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观察管道`)
};

const tr_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzlenen ardışık düzen`)
};

const ru_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просматриваемый конвейер`)
};

const pl_svc_web_scraping_harden_output6 = /** @type {(inputs: Svc_Web_Scraping_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwowany potok`)
};

/**
* | output |
* | --- |
* | "Watched pipeline" |
*
* @param {Svc_Web_Scraping_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_harden_output6 = /** @type {((inputs?: Svc_Web_Scraping_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_harden_output6(inputs)
	if (locale === "bn") return bn_svc_web_scraping_harden_output6(inputs)
	if (locale === "de") return de_svc_web_scraping_harden_output6(inputs)
	if (locale === "es") return es_svc_web_scraping_harden_output6(inputs)
	if (locale === "fr") return fr_svc_web_scraping_harden_output6(inputs)
	if (locale === "pt") return pt_svc_web_scraping_harden_output6(inputs)
	if (locale === "zh") return zh_svc_web_scraping_harden_output6(inputs)
	if (locale === "tr") return tr_svc_web_scraping_harden_output6(inputs)
	if (locale === "ru") return ru_svc_web_scraping_harden_output6(inputs)
	if (locale === "pl") return pl_svc_web_scraping_harden_output6(inputs)
	return en_svc_web_scraping_harden_output6(inputs)
});
export { svc_web_scraping_harden_output6 as "svc_web-scraping_HARDEN_output" }